module.exports = __webpack_public_path__ + "static/logo-c1e682a50dd54ceadedd7f4ec4baa5ce.svg";